import {
  ArrowRightIcon,
  Box,
  Button,
  Typography,
  CheckCircleIcon,
  ClockIcon,
  CreditCardIcon,
} from '@ttx/design-system';
import {useRouter} from 'next/router';
import React, {FC} from 'react';

interface IStripeSuccessModel {
  trxHash?: string;
  isMobile: boolean;
}

export const StripeSuccessModel: FC<IStripeSuccessModel> = ({
  trxHash,
  isMobile,
}) => {
  const router = useRouter();

  const handleRedirect = () => {
    router.push('/my-nfts');
  };

  return (
    <>
      <Box display="flex" flexDirection="column" alignItems="center">
        <CheckCircleIcon
          size={64}
          color="brandPrimary"
          style={{paddingBottom: 4}}
        />
        <Typography
          color="textDefault"
          textStyle="h2"
          style={{paddingRight: 16}}
        >
          Boom!! Purchase Successful
        </Typography>

        <Box mt="lg" width="100%">
          {/* NFT Transfer Info */}
          <Box display="flex" alignItems="flex-start" mb="md">
            <Box mr="s">
              <ClockIcon size={24} color="textLow" style={{paddingBlock: 6}} />
            </Box>
            <Box>
              <Typography color="textDefault" textStyle="s" fontWeight="bold">
                NFT Transfer in Progress
              </Typography>
              <Typography color="textDefault" textStyle="s">
                Your NFT will be transferred to your wallet and appear in
                &apos;My Collectibles&apos;
              </Typography>
              <Typography color="textLow" textStyle="xs">
                This process may take up to 5 minutes
              </Typography>
            </Box>
          </Box>

          {/* Refund Info */}
          <Box display="flex" alignItems="flex-start">
            <Box mr="s">
              <CreditCardIcon
                size={24}
                color="textLow"
                style={{paddingBlock: 6}}
              />
            </Box>
            <Box>
              <Typography color="textDefault" textStyle="s" fontWeight="bold">
                Payment Protection
              </Typography>
              <Typography color="textDefault" textStyle="s">
                If transaction fails, instant refund will be initiated
              </Typography>
              <Typography color="textLow" textStyle="xs">
                Refunds typically process in 2-3 business days
              </Typography>
            </Box>
          </Box>
        </Box>

        {!!trxHash && (
          <Box mt="md">
            <Typography color="textLow" textStyle="xs">
              Transaction ID: #{trxHash}
            </Typography>
          </Box>
        )}

        <Button
          type="primary"
          size="M"
          onPress={handleRedirect}
          buttonStyle={{margin: '24px 0 0 0'}}
          leftAccessory={<ArrowRightIcon color="textInvert" />}
        >
          View My NFT
        </Button>
      </Box>
    </>
  );
};
